export type vesselType = { type: string; src: string };

export const vesselTypes: vesselType[] = [
  { type: "sailboat", src: "" },
  { type: "catamaran", src: "" },
  { type: "schooner", src: "" },
  { type: "canoe", src: "" },
  { type: "yacht", src: "" },
  { type: "speedboat", src: "" },
];
